export const vatZeroPerData = [
    {
        "id": "1",
        "code": "1",
        "english": "Without VAT - Article 2 and 3 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 2 και 3 του Κώδικα ΦΠΑ"
    },
    {
        "id": "2",
        "code": "2",
        "english": "Without VAT - Article 5 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 5 του Κώδικα ΦΠΑ"
    },
    {
        "id": "3",
        "code": "3",
        "english": "Without VAT - Article 17 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 17 του Κώδικα ΦΠΑ"
    },
    {
        "id": "4",
        "code": "4",
        "english": "Without VAT - Article 18 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 18 του Κώδικα ΦΠΑ"
    },
    {
        "id": "5",
        "code": "5",
        "english": "Without VAT - Article 21 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 21 του Κώδικα ΦΠΑ"
    },
    {
        "id": "6",
        "code": "6",
        "english": "Without VAT - Article 24 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 24 του Κώδικα ΦΠΑ"
    },
    {
        "id": "7",
        "code": "7",
        "english": "Without VAT - Article 27 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 27 του Κώδικα ΦΠΑ"
    },
    {
        "id": "8",
        "code": "8",
        "english": "Without VAT - Article 29 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 29 του Κώδικα ΦΠΑ"
    },
    {
        "id": "9",
        "code": "9",
        "english": "Without VAT - Article 30 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 30 του Κώδικα ΦΠΑ"
    },
    {
        "id": "10",
        "code": "10",
        "english": "Without VAT - Article 31 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 31 του Κώδικα ΦΠΑ"
    },
    {
        "id": "11",
        "code": "11",
        "english": "Without VAT - Article 32 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 32 του Κώδικα ΦΠΑ"
    },
    {
        "id": "12",
        "code": "12",
        "english": "Without VAT - Article 32 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 32 του Κώδικα ΦΠΑ - Πλοία Ανοικτής Θαλάσσης του Κώδικα ΦΠΑ"
    },
    {
        "id": "13",
        "code": "13",
        "english": "Without VAT - Article 32 .1.γ. - Open Sea Vessels of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 32 .1.γ. του Κώδικα ΦΠΑ - Πλοία Ανοικτής Θαλάσσης του Κώδικα ΦΠΑ"
    },
    {
        "id": "14",
        "code": "14",
        "english": "Without VAT - Article 33 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 33 του Κώδικα ΦΠΑ"
    },
    {
        "id": "15",
        "code": "15",
        "english": "Without VAT - Article 44 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 44 του Κώδικα ΦΠΑ"
    },
    {
        "id": "16",
        "code": "16",
        "english": "Without VAT - Article 45 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 45 του Κώδικα ΦΠΑ"
    },
    {
        "id": "17",
        "code": "17",
        "english": "Without VAT - Article 47 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 47 του Κώδικα ΦΠΑ"
    },
    {
        "id": "18",
        "code": "18",
        "english": "Without VAT - Article 48 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 48 του Κώδικα ΦΠΑ"
    },
    {
        "id": "19",
        "code": "19",
        "english": "Without VAT - Article 54 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 54 του Κώδικα ΦΠΑ"
    },
    {
        "id": "20",
        "code": "20",
        "english": "VAT Included - Article 50 of the VAT Code",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 50 του Κώδικα ΦΠΑ"
    },
    {
        "id": "21",
        "code": "21",
        "english": "VAT Included - Article 51 of the VAT Code",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 51 του Κώδικα ΦΠΑ"
    },
    {
        "id": "22",
        "code": "22",
        "english": "VAT Included - Article 52 of the VAT Code",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 52 του Κώδικα ΦΠΑ"
    },
    {
        "id": "23",
        "code": "23",
        "english": "VAT Included - Article 53 of the VAT Code",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 53 του Κώδικα ΦΠΑ"
    },
    {
        "id": "24",
        "code": "24",
        "english": "Without VAT - Article 8 of the VAT Code",
        "description": "Χωρίς ΦΠΑ - άρθρο 8 του Κώδικα ΦΠΑ"
    },
    {
        "id": "25",
        "code": "25",
        "english": "Without VAT - POL.1029/1995",
        "description": "Χωρίς ΦΠΑ - ΠΟΛ.1029/1995"
    },
    {
        "id": "26",
        "code": "26",
        "english": "Without VAT - POL.1167/2015",
        "description": "Χωρίς ΦΠΑ - ΠΟΛ.1167/2015"
    },
    {
        "id": "27",
        "code": "27",
        "english": "Other VAT Exemptions",
        "description": "Λοιπές Εξαιρέσεις ΦΠΑ"
    },
    {
        "id": "28",
        "code": "28",
        "english": "Without VAT – Article 29, case β', paragraph 1 of the VAT Code (Tax Free)",
        "description": "Χωρίς ΦΠΑ – άρθρο 29 περ. β’ παρ.1 του Κώδικα ΦΠΑ, (Tax Free)"
    },
    {
        "id": "29",
        "code": "29",
        "english": "Without VAT – Article 56 of the VAT Code (OSS Non-Union Scheme)",
        "description": "Χωρίς ΦΠΑ – άρθρο 56 του Κώδικα ΦΠΑ (OSS_μη ενωσιακό καθεστώς)"
    },
    {
        "id": "30",
        "code": "30",
        "english": "Without VAT – Article 57 of the VAT Code (OSS Union Scheme)",
        "description": "Χωρίς ΦΠΑ – άρθρο 57 του Κώδικα ΦΠΑ (OSS_ενωσιακό καθεστώς)"
    },
    {
        "id": "31",
        "code": "31",
        "english": "Without VAT – Article 58 of the VAT Code (IOSS)",
        "description": "Χωρίς ΦΠΑ – άρθρο 58 του Κώδικα ΦΠΑ (IOSS)"
    }
]
